import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { SensorManagementPort, CreateSensorData, UpdateSensorData, DeleteSensorData, MoveSensorData } from '../../domain/ports/SensorManagementPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseSensorManagementAdapter implements SensorManagementPort {
  private readonly prefix = 'sensors';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async createSensor(data: CreateSensorData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-createSensor`;
    this.logger.logRepositoryRequest('SensorManagementAdapter', 'createSensor', { functionName, data });
    
    try {
      const createSensorFn = httpsCallable(functions, functionName);
      const result = await createSensorFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('SensorManagementAdapter', 'createSensor', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('SensorManagementAdapter', 'createSensor', duration, error);
      console.error('Create sensor error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async updateSensor(data: UpdateSensorData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateSensor`;
    this.logger.logRepositoryRequest('SensorManagementAdapter', 'updateSensor', { functionName, data });
    
    try {
      const updateSensorFn = httpsCallable(functions, functionName);
      const result = await updateSensorFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('SensorManagementAdapter', 'updateSensor', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('SensorManagementAdapter', 'updateSensor', duration, error);
      console.error('Update sensor error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async deleteSensor(data: DeleteSensorData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-deleteSensor`;
    this.logger.logRepositoryRequest('SensorManagementAdapter', 'deleteSensor', { functionName, data });
    
    try {
      const deleteSensorFn = httpsCallable(functions, functionName);
      const result = await deleteSensorFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('SensorManagementAdapter', 'deleteSensor', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('SensorManagementAdapter', 'deleteSensor', duration, error);
      console.error('Delete sensor error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async moveSensor(data: MoveSensorData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-moveSensor`;
    this.logger.logRepositoryRequest('SensorManagementAdapter', 'moveSensor', { functionName, data });
    
    try {
      const moveSensorFn = httpsCallable(functions, functionName);
      const result = await moveSensorFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('SensorManagementAdapter', 'moveSensor', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('SensorManagementAdapter', 'moveSensor', duration, error);
      console.error('Move sensor error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }
}